/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

const ElectroCheckbox: React.StatelessFunctionalComponent<*> = ({
  field,
  onChange = null,
  disabled = false,
}: Object) => (
  <FormControlLabel
    control={
      <Checkbox
        {...field.bind()}
        disabled={disabled}
        checked={field.value}
        type="checkbox"
        value={field.value.toString()}
        onChange={() => {
          field.set(!field.value);
          if (onChange) onChange(field);
        }}
      />
    }
    label={field.title || field.label}
  />
);

export default observer(ElectroCheckbox);
